
import React, { useState, useEffect, useRef } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  CardBody,
  Card,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import { FaArrowLeft } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";


import DOMPurify from 'dompurify';


import Image1 from "../../assets/xrayimages/OIP.jpg";
import EditImage from "../../assets/xrayimages/document_1822225.png";
import DownloadIcon from "../../assets/xrayimages/download-svgrepo-com.svg";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API_URL, IMAGE_URL,IMAGE_URL2 } from "../../global";
import { FaFolder, FaFolderOpen } from "react-icons/fa";
import ChartsComponent from "./Charts";
import RecentList from "./RecentList";
import { FaChevronDown, FaChevronUp, FaImage, FaEquals } from "react-icons/fa";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXRay } from "@fortawesome/free-solid-svg-icons";
import { BsDownload } from "react-icons/bs";
import { CiEdit } from "react-icons/ci";
// import XrayImage from "../../assets/images/custom/xray.png";
import XrayImage from "../../assets/images/custom/Dental.png";
import { GoHistory } from "react-icons/go";
import Select from "react-select";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import chatbot from "../../assets/images/custom/artificial-intelligence_6138791.eb64b56f04ef0d1f94.png";
import { connect } from "react-redux";
import debounce from "lodash/debounce";
import TypingHTML from "./TypeWritting";

const Dashboard = ({ searchTerm }) => {
  document.title = "Dental Kiosk";
  const navigate = useNavigate();
  const latestValuesRef = useRef({ id: "", accessionno: "" });
  const [isChatPopupOpen, setIsChatPopupOpen] = useState(false);
  const [question, setQuestion] = useState("");
  const [conversation, setConversation] = useState([]);
  const [submittedQuery, setSubmittedQuery] = useState("");
  const [queryMode, setQueryMode] = useState("normal");
  const [modalOpen, setModalOpen] = useState(false);
  const [submittedData, setSubmittedData] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    id: "",
    accessionno: "",
    dob: "",
    centre: "",
    physician: "",
    date: "",
    image: null,
    gender: null,
  });


  console.log("Images_Result",formData.image);
  
  const [selectedPatient, setSelectedPatient] = useState(null);

  const [errors, setErrors] = useState({});
  const [expandedPatients, setExpandedPatients] = useState({});

  const [patients, setPatients] = useState([]);
  const [imageModalOpen, setImageModalOpen] = useState(false);
  const [selectedPatientForImage, setSelectedPatientForImage] = useState(null);
  // const [newImageFile, setNewImageFile] = useState(null);
  const [groupedPatients, setGroupedPatients] = useState({});
  const [errors1, setErrors1] = useState({});
  const [formData1, setFormData1] = useState({
    centre1: "",
    physician1: "",
    date1: "",
    image1: null,
  });
  const [loading, setLoading] = useState(false);
  const [loading1, setLoading1] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [historyList, setHistoryList] = useState([]);
  const [showLeft, setShowLeft] = useState(true);
  const [showRight, setShowRight] = useState(true);
  const [patientIdExists, setPatientIdExists] = useState(false);
  const [accessionExists, setAccessionExists] = useState(false);

  const messagesEndRef = useRef(null);

  const fetchData = async () => {
    if (!selectedPatient?.case_id) return; // Return if there's no patient or case_id

    setLoading(true);
    try {
      const response = await fetch(`${API_URL}/ask_Question`);
      if (!response.ok) throw new Error("Failed to fetch patient data");
      const data = await response.json();

      
      const filteredData = data
      .filter((item) => item.fk_case_id === selectedPatient.case_id)
      .map((item) => ({
        ...item,
        isNew: false,  // mark all history messages as NOT new
      }));

    setConversation(filteredData);
    } catch (error) {
      console.error("Error fetching patient data:", error);
    } finally {
      setLoading(false);
    }
  };

  
  useEffect(() => {
    if (selectedPatient) {
      fetchData();
    }
  }, [selectedPatient]); 

  
  useEffect(() => {
    if (isChatPopupOpen && messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [isChatPopupOpen, conversation]); 

  
  const toggleChatPopup = () => {
    setIsChatPopupOpen(!isChatPopupOpen);
    if (!isChatPopupOpen) {
      
      fetchData()
      setQuestion("");
    }
  };

  const [showWarning, setShowWarning] = useState(false);

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      
      e.preventDefault(); 

      
      setConversation((prev) => [
        ...prev,
        { question: question, answer: "..." }, 
      ]);

      
      handleSubmitQuestion();
    }
  };

  
  const handleSubmitQuestion = async () => {
    if (!selectedPatient) {
     
      setShowWarning(true);
      return; 
    }
    if (!question.trim()) return;

    const caseId = selectedPatient?.case_id; 
    const file_name = selectedPatient?.file_name;
    const user_msg = question; 

    const requestData = { caseId, user_msg, file_name };

    console.log("Submitting:", requestData);

    
    await sendQueryToAPI(requestData);

    
    setQuestion(""); 
  };

  
  const sendQueryToAPI = async (data) => {
    try {
      const response = await fetch(`${API_URL}/ask_Question`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      const result = await response.json();
      console.log("API Response:", result);

      
      setConversation((prev) => {
        const updatedConversation = [...prev];
        updatedConversation[updatedConversation.length - 1] = {
          ...updatedConversation[updatedConversation.length - 1],
          answer: result.answer, 
          isNew: true,
        };
        return updatedConversation;
      });
    } catch (error) {
      console.error("Error sending query:", error);
    }
  };

  const filteredPatients = Object.entries(groupedPatients).filter(
    ([_, patientData]) =>
      patientData.patient_name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const genderOptions = [
    { label: "Male", value: "1" },
    { label: "Female", value: "2" },
  ];
  const [originalPatient, setOriginalPatient] = useState(null);

  
  const [filteredHistoryList, setFilteredHistoryList] = useState([]);

  const handleHistoryClick = (report) => {
    if (!selectedPatient) return;

    const filtered = historyList.filter(
      (patient) => patient.patient_id === selectedPatient.patient_id
    );

    setSelectedPatient(report);
    setOriginalPatient(selectedPatient);
    setFilteredHistoryList(filtered);
    setDropdownOpen(false);
    setViewingHistory(true);
  };

  // Open modal and set selected patient
  const openImageUploadModal = (patient) => {
    setSelectedPatientForImage(patient);
    setImageModalOpen(true);
  };



  const [viewingHistory, setViewingHistory] = useState(false);

  const handleSubmitQuestionvisulize = () => {
    if (!question.trim()) return;
    setQueryMode("visualize"); // Set mode to visualize
    setSubmittedQuery(question); // Trigger API call
    setConversation((prev) => [...prev, { question, answer: "..." }]);
    setQuestion(""); // Clear input field
  };

  // Trigger API on "Graph View" button click
  const handleGraphView = () => {
    // fetchChatResponseGraphint();
  };
  const closeImageUploadModal = () => {
    setImageModalOpen(false);
  };

  const fetchPatients = async () => {
    setLoading(true);

    try {
      // const response = await fetch(`${API_URL}/case_info`);
      const userId = sessionStorage.getItem("user_id");
      const response = await fetch(`${API_URL}/case_info?user_id=${userId}`);

      if (!response.ok) throw new Error("Failed to fetch patient data");

      const data = await response.json();
      const activePatients = {};
      const historyPatients = [];

      data.forEach((patient) => {
        if (patient.active_status === 1) {
          // Active Patients (Grouped)
          const key = patient.fk_pc_id;

          if (!activePatients[key]) {
            activePatients[key] = {
              patient_name: patient.patient_name,
              pk_pc_id: patient.pk_pc_id,
              images: [],
            };
          }

          activePatients[key].images.push({
            case_id: patient.pk_case_id,
            pk_pc_id: patient.pk_pc_id,
            gender: patient.gender,
            file_name: patient.file_name,
            title: patient.title || "No Title",
            summary: patient.summary || "No summary available.",
            data_points:
              patient.data_points || "<p>No observations available.</p>",
            provider: patient.provider,
            organization: patient.organization,
            service_date: patient.service_date,
            patient_id: patient.patient_id,
            accession_no: patient.accession_no,
            patient_dob: patient.patient_dob,
            cm_created_at: patient.cm_created_at,
            pc_created_at: patient.pc_created_at,
          });
        } else {
          // History Patients (List)
          historyPatients.push({
            id: patient.pk_case_id,
            pk_pc_id: patient.pk_pc_id,
            gender: patient.gender,
            title: patient.title || "No Title",
            created_at: new Date(patient.ed_created_at + "Z").toLocaleString(
              "en-IN",
              {
                timeZone: "Asia/Kolkata",
                year: "numeric",
                month: "short",
                day: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
                hour12: true,
              }
            ),
            patient_name: patient.patient_name,
            organization: patient.organization,
            provider: patient.provider,
            service_date: patient.service_date,
            summary: patient.summary,
            data_points: patient.data_points,
            pc_created_at: patient.pc_created_at,
            patient_id: patient.patient_id,
          });
        }
      });

      console.log("Active Patients:", activePatients);
      console.log("History List:", historyPatients);

      setGroupedPatients(activePatients);
      setHistoryList(historyPatients);
    } catch (error) {
      console.error("Error fetching patients:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPatients();
  }, []);

  console.log("patients", patients);

  const togglePatient = (patientId) => {
    setExpandedPatients((prev) => ({
      ...prev,
      [patientId]: !prev[patientId],
    }));
  };

  const [editedContent, setEditedContent] = useState({
    title: "",
    summary: "",
    keyObservations: [],
    
  });

  const toggleModal = (patient = null) => {
    if (patient) {
      setEditedContent({
        title: patient.title || "Patient X-ray Report",
        
        summary: patient.summary
  ? extractParagraphText(patient.summary)
  : ["No summary available."],
        keyObservations: patient.data_points
          ? extractKeyFeatures(patient.data_points)
          : [],
        
      });
    } else {
      setEditedContent({
        title: "",
        summary: "",
        keyObservations: [],
        
      });
    }
    setModalOpen(!modalOpen);
  };

  console.log("editedContent", editedContent);

  const extractKeyFeatures = (htmlContent) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = htmlContent || "";
    return [...tempDiv.querySelectorAll("h5, li")].map((li) => li.textContent);
  };


  const extractParagraphText = (htmlContent) => {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = htmlContent || "";
  
  const paragraphs = [...tempDiv.querySelectorAll("p")].map(p => p.textContent.trim());
  return paragraphs.join(" "); // You can also join with "\n" if you want line breaks.
};

  const handleInputChange = (e, field) => {
    setEditedContent({ ...editedContent, [field]: e.target.value });
  };

  const handleListChange = (e, field, index) => {
    const newList = [...editedContent[field]];
    newList[index] = e.target.value;
    setEditedContent({ ...editedContent, [field]: newList });
  };

  const handleSave = () => {
    toggleModal();
  };



  const handleSaveEdit = async () => {
    if (!selectedPatient) return;

    const updatedData = {
      caseId: selectedPatient.case_id,
      title: editedContent.title || selectedPatient.title,
      // summary: editedContent.summary || selectedPatient.summary,
      summary: editedContent.summary
  ? `<p>${editedContent.summary.trim()}</p>`
  : selectedPatient.summary,

     

      data_points:
  editedContent.keyObservations.length > 0
    ? updateDataPoints(selectedPatient.data_points, editedContent.keyObservations)
    : selectedPatient.data_points,

    };
    

    try {
      const response = await fetch(`${API_URL}/edit_info`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(updatedData),
      });

      if (!response.ok) throw new Error("Failed to update report");

      const updatedPatient = {
        ...selectedPatient,
        title: updatedData.title,
        summary: updatedData.summary,
        data_points: updatedData.data_points,
      };
      setSelectedPatient(updatedPatient);

      toast.success("Report successfully updated!", {
        position: "top-right",
        autoClose: 3000,
      });
      toggleModal();
      fetchPatients();
    } catch (error) {
      console.error("Error updating report:", error);
      toast.error("Update failed. Please try again.", {
        position: "top-right",
        autoClose: 3000,
      });
    }
  };


  function updateDataPoints(originalHTML, newObservations) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(originalHTML, 'text/html');


  const listItems = Array.from(doc.querySelectorAll('section ul li'));


  newObservations.forEach((obs, i) => {
    if (listItems[i]) {
      listItems[i].innerHTML = obs;  
    }
  });

  return doc.body.innerHTML;
}


  const handleDownloadPDF = () => {
    if (!selectedPatient) {
      console.error("No patient selected!");
      return;
    }

    const pdf = new jsPDF("p", "mm", "a4");
    let currentY = 15; // Track current Y position dynamically
    const pageHeight = 280; // Page height limit

    // --- Title ---
    pdf.setFont("helvetica", "bold");
    pdf.setFontSize(18);
    pdf.text("Patient X-Ray Report", 105, currentY, { align: "center" });
    currentY += 15;

    // --- Patient Details ---
    pdf.setFontSize(12);
    pdf.setFont("helvetica", "bold");
    pdf.text("Patient Details:", 10, currentY);
    pdf.setFont("helvetica", "normal");
    currentY += 7;

    const patientDetails = [
      `Patient Name: ${selectedPatient.patient_name || "Unknown"}`,
      `X-Ray Centre: ${selectedPatient.organization || "N/A"}`,
      `Referring Physician: ${selectedPatient.provider || "N/A"}`,
      `Study Date: ${selectedPatient.service_date || "N/A"}`,
    ];

    patientDetails.forEach((line) => {
      if (currentY + 7 > pageHeight) {
        pdf.addPage();
        currentY = 20;
      }
      pdf.text(line, 10, currentY);
      currentY += 7;
    });

    currentY += 5;

    // --- Report Details ---
    pdf.setFont("helvetica", "bold");
    pdf.setFontSize(14);
    pdf.text("Report Details:", 10, currentY);
    pdf.setFont("helvetica", "normal");
    currentY += 10;

    const addSection = (title, content) => {
      pdf.setFont("helvetica", "bold");
      pdf.setFontSize(14);
      pdf.text(title, 10, currentY);
      pdf.setFont("helvetica", "normal");
      currentY += 7;

      const contentLines = pdf.splitTextToSize(content || "N/A", 180);
      contentLines.forEach((line) => {
        if (currentY + 7 > pageHeight) {
          pdf.addPage();
          currentY = 20;
        }
        pdf.text(line, 10, currentY);
        currentY += 7;
      });

      currentY += 5; // Space after section
    };

    addSection("Title:", selectedPatient.title);
    // addSection("Summary:", selectedPatient.summary);
   

addSection("Summary:", stripHtmlTags(selectedPatient.summary));

    // --- Key Observations ---
    pdf.setFont("helvetica", "bold");
    pdf.setFontSize(14);
    pdf.text("Key Observations:", 10, currentY);
    pdf.setFont("helvetica", "normal");
    currentY += 7;

    if (selectedPatient.data_points) {
      let rawData = selectedPatient.data_points;

      // Extract <li>, <h5>, <div> as bullet points
      let bulletPoints = rawData.match(/<(li|h5|div)[^>]*>(.*?)<\/\1>/gi) || [];
      let formattedPoints = bulletPoints.map((point) =>
        point.replace(/<[^>]*>/g, "").trim()
      );

      formattedPoints.forEach((point) => {
        const wrappedText = pdf.splitTextToSize(`• ${point}`, 180);

        wrappedText.forEach((line) => {
          if (currentY + 7 > pageHeight) {
            pdf.addPage();
            currentY = 20;
          }
          pdf.text(line, 10, currentY);
          currentY += 7;
        });

        currentY += 3; // Small space between points
      });
    } else {
      pdf.text("No detailed report available.", 10, currentY);
      currentY += 7;
    }

    // Generate and Save PDF
    const patientName = selectedPatient?.patient_name
      ? selectedPatient.patient_name.replace(/\s+/g, "_")
      : "Unknown";
    pdf.save(`Xray_Report-${patientName}.pdf`);
  };



 function stripHtmlTags(htmlString) {
  const doc = new DOMParser().parseFromString(htmlString, "text/html");
  return doc.body.textContent || "";
}

const handleFormChange1 = (e) => {
  const { name, value, files } = e.target;

  if (name === "image1") {
    const selectedFiles = Array.from(files); // ✅ always an array

    console.log("📁 Selected Files:", selectedFiles);

    const allowedTypes = ["image/jpeg", "image/png", "image/webp"];
    const maxSize = 2 * 1024 * 1024; // 2MB
    const minSize = 1 * 1024; // 1KB

    const validFiles = [];
    let errorMsg = "";

    for (let file of selectedFiles) {
      console.log(`🔍 Checking file: ${file.name}, size: ${file.size}, type: ${file.type}`);
      if (!allowedTypes.includes(file.type)) {
        errorMsg = "Only JPEG, PNG, and WEBP image files are allowed.";
        break;
      } else if (file.size > maxSize) {
        errorMsg = "Image file is too large. Max allowed size is 2MB.";
        break;
      } else if (file.size < minSize) {
        errorMsg = "Image file is too small. Minimum size is 1KB.";
        break;
      } else {
        validFiles.push(file);
      }
    }

    if (errorMsg) {
      console.warn("❌ Validation Error:", errorMsg);
      setErrors1({ ...errors1, image1: errorMsg });
    } else {
      const updatedErrors = { ...errors1 };
      delete updatedErrors.image1;
      setErrors1(updatedErrors);
      setFormData1({ ...formData1, image1: validFiles }); // ✅ always array

      console.log("✅ Valid files saved to formData1.image1:", validFiles);
    }
  } else {
    setFormData1({ ...formData1, [name]: value });
    console.log(`✏️ Updated field "${name}":`, value);
  }
};


  const validateField = debounce(async (fieldType, fieldValue, setExists) => {
    // Don't validate empty input
    if (!fieldValue.trim()) {
      setExists(false);
      return;
    }

    try {
      const response = await fetch(
        `${API_URL}/DentalNewCasePage?field_type=${fieldType}&field_value=${encodeURIComponent(
          fieldValue
        )}`
      );

      const data = await response.json();

      // Only update exists if the current value is still the same
      if (
        latestValuesRef.current[
          fieldType === "patient_id" ? "id" : "accessionno"
        ] === fieldValue
      ) {
        setExists(data.exists);
      }
    } catch (err) {
      console.error("Validation error:", err);
      setExists(false);
    }
  }, 300); // 300ms debounce




  const handleFormChange = (e) => {
  const { name, value, files } = e.target;

  if (name === "dob") {
    const selectedDate = new Date(value);
    const today = new Date();

    if (selectedDate > today) {
      setErrors({ ...errors, dob: "Date of Birth cannot be in the future." });
    } else {
      const updatedErrors = { ...errors };
      delete updatedErrors.dob;
      setErrors(updatedErrors);
      setFormData({ ...formData, dob: value });
    }
 } else if (name === "image") {
  const selectedFiles = Array.from(files);

  const allowedTypes = ["image/jpeg", "image/png", "image/webp"];
  const maxSize = 2 * 1024 * 1024; // 2MB
  const minSize = 1 * 1024; // 1KB

  const validFiles = [];
  let imageError = "";

  for (let file of selectedFiles) {
    if (!allowedTypes.includes(file.type)) {
      imageError = "Only JPEG, PNG, and WEBP image files are allowed.";
    } else if (file.size > maxSize) {
      imageError = "Image file is too large. Max allowed size is 2MB.";
    } else if (file.size < minSize) {
      imageError = "Image file is too small. Minimum size is 1KB.";
    } else {
      validFiles.push(file);
    }
  }

  if (imageError) {
    setErrors({ ...errors, image: imageError });
  } else {
    const updatedErrors = { ...errors };
    delete updatedErrors.image;
    setErrors(updatedErrors);
    setFormData({ ...formData, image: validFiles }); // ✅ Store all valid files
  }
}

  else if (name === "id") {
    latestValuesRef.current.id = value;
    setFormData((prev) => ({ ...prev, id: value }));
    setPatientIdExists(false); // Reset on input change
    validateField("patient_id", value, setPatientIdExists);
  } else if (name === "accessionno") {
    latestValuesRef.current.accessionno = value;
    setFormData((prev) => ({ ...prev, accessionno: value }));
    setAccessionExists(false); // Reset on input change
    validateField("accession_no", value, setAccessionExists);
  } else {
    setFormData({ ...formData, [name]: value });
  }
};


  const validateForm = () => {
    let newErrors = {};
    const today = new Date();
  
    if (!formData.name.trim()) {
      newErrors.name = "Patient name is required.";
    } else if (/^\s/.test(formData.name)) {
      newErrors.name = "Name should not start with a space.";
    } else if (/\d/.test(formData.name)) {
      newErrors.name = "Name should not contain numbers.";
    } else if (formData.name.length < 3 || formData.name.length > 50) {
      newErrors.name = "Name must be between 3 and 50 characters.";
    }

    if (!formData.id.trim()) {
      newErrors.id = "Patient ID is required.";
    } else if (/^\s/.test(formData.id)) {
      newErrors.id = "Patient ID should not start with a space.";
    } else if (!/^[A-Za-z0-9]+$/.test(formData.id)) {
      newErrors.id = "Patient ID should only contain letters and numbers.";
    } else if (formData.id.length < 3 || formData.id.length > 15) {
      newErrors.id = "Patient ID must be between 3 and 12 characters.";
    }


    if (!formData.accessionno.trim()) {
      newErrors.accessionno = "Accession number is required.";
    } else if (/^\s/.test(formData.accessionno)) {
      newErrors.accessionno = "Accession number should not start with a space.";
    } else if (!/^[A-Za-z0-9]+$/.test(formData.accessionno)) {
      newErrors.accessionno =
        "Accession number should only contain letters and numbers.";
    } else if (
      formData.accessionno.length < 3 ||
      formData.accessionno.length > 15
    ) {
      newErrors.accessionno =
        "Accession number must be between 3 and 12 characters.";
    }

  
    if (!formData.centre.trim()) {
      newErrors.centre = "X-ray Centre is required.";
    } else if (/^\s/.test(formData.centre)) {
      newErrors.centre = "Centre should not start with a space.";
    } else if (formData.centre.length < 3 || formData.centre.length > 50) {
      newErrors.centre = "X-ray Centre must be between 3 and 50 characters.";
    }

    if (!formData.physician.trim()) {
      newErrors.physician = "Referring Physician is required.";
    } else if (/^\s/.test(formData.physician)) {
      newErrors.physician = "Physician name should not start with a space.";
    } else if (!/^[A-Za-z.\s]+$/.test(formData.physician)) {
      newErrors.physician =
        "Physician name should contain only letters, spaces, and periods.";
    } else if (
      formData.physician.length < 3 ||
      formData.physician.length > 50
    ) {
      newErrors.physician =
        "Physician name must be between 3 and 50 characters.";
    }

    const minStudyDate = new Date();
    minStudyDate.setFullYear(today.getFullYear() - 5);

    if (!formData.date) {
      newErrors.date = "Study Date is required.";
    } else {
      const studyDate = new Date(formData.date);
      if (studyDate > today) {
        newErrors.date = "Study Date cannot be in the future.";
      } else if (studyDate < minStudyDate) {
        newErrors.date =
          "Study Date is too old. Please enter a date within the last 10 years.";
      }
    }
    if (!formData.image) newErrors.image = "Please select an image.";
    if (!formData.gender) {
      newErrors.gender = "Please select a gender";
    }

    const minDOB = new Date();
    minDOB.setFullYear(today.getFullYear() - 100); 

    if (!formData.dob) {
      newErrors.dob = "Date of birth is required.";
    } else {
      const dobDate = new Date(formData.dob);
      if (dobDate > today) {
        newErrors.dob = "Date of Birth cannot be in the future.";
      } else if (dobDate < minDOB) {
        newErrors.dob = "Date of Birth is too old. Please enter a valid date.";
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validateForm1 = () => {
    let newErrors = {};
    const today = new Date();


    if (!formData1.centre1.trim()) {
      newErrors.centre1 = "X-ray Centre is required.";
    } else if (/^\s/.test(formData1.centre1)) {
      newErrors.centre1 = "Centre should not start with a space.";
    } else if (formData1.centre1.length < 3 || formData1.centre1.length > 50) {
      newErrors.centre1 = "X-ray Centre must be between 3 and 50 characters.";
    }


    if (!formData1.physician1.trim()) {
      newErrors.physician1 = "Referring Physician is required.";
    } else if (/^\s/.test(formData1.physician1)) {
      newErrors.physician1 = "Physician name should not start with a space.";
    } else if (!/^[A-Za-z.\s]+$/.test(formData1.physician1)) {
      newErrors.physician1 =
        "Physician name should contain only letters, spaces, and periods.";
    } else if (
      formData1.physician1.length < 3 ||
      formData1.physician1.length > 50
    ) {
      newErrors.physician1 =
        "Physician name must be between 3 and 50 characters.";
    }

    const minStudyDate = new Date();
    minStudyDate.setFullYear(today.getFullYear() - 5);

    if (!formData1.date1) {
      newErrors.date1 = "Study Date is required.";
    } else {
      const studyDate = new Date(formData1.date1);
      if (studyDate > today) {
        newErrors.date1 = "Study Date cannot be in the future.";
      } else if (studyDate < minStudyDate) {
        newErrors.date1 =
          "Study Date is too old. Please enter a date within the last 10 years.";
      }
    }
    if (!formData1.image1) newErrors.image1 = "Please select an image.";

    setErrors1(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleGenderChange = (selectedOption) => {
    setFormData({
      ...formData,
      gender: selectedOption,
    });
  };

  const [submissionTriggerCount, setSubmissionTriggerCount] = useState(0);

  
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm() && patientIdExists && accessionExists) return;

   
    setSubmissionTriggerCount((prev) => prev + 1);


    setLoading(true);

    const formDataToSend = new FormData();

    const userId = sessionStorage.getItem("user_id");

    formDataToSend.append("name", formData.name);
    formDataToSend.append("id", userId);
    formDataToSend.append("accessionno", formData.accessionno);
    formDataToSend.append("dob", formData.dob);
    formDataToSend.append("centre", formData.centre);
    formDataToSend.append("physician", formData.physician);
    formDataToSend.append("date", formData.date);
    formDataToSend.append(
      "genno",
      formData.gender ? formData.gender.value : ""
    );
    formDataToSend.append("mode", "new_patient");

    
    if (formData.image && formData.image.length > 0) {
  formData.image.forEach((img) => {
    formDataToSend.append("image", img);
  });
}

    // Debugging: Log form data before sending
    for (let pair of formDataToSend.entries()) {
      console.log(pair[0] + ": " + pair[1]);
    }

    try {

      console.log("testing_Demo", formDataToSend)
      const response = await fetch(`${API_URL}/DentalNewCasePage`, {
        method: "POST",
        body: formDataToSend,
      });

      if (!response.ok) {
        throw new Error("Failed to upload data");
      }

      toast.success("Submission successfully!", {
        position: "top-right",
        autoClose: 3000,
      });
      setFormData({
        name: "",
        id: "",
        accessionno: "",
        dob: "",
        centre: "",
        physician: "",
        date: "",
        image: null,
      });
      setErrors({});
      fetchPatients();
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error("Submission failed. Please try again.", {
        position: "top-right",
        autoClose: 3000,
      });

       if (toastTimeoutRef.current) {
    clearTimeout(toastTimeoutRef.current);
    toastTimeoutRef.current = null;
  }
  if (toastIdRef.current) {
    toast.dismiss(toastIdRef.current);
    toastIdRef.current = null;
  }

  setSubmissionTriggered(false); 
    } finally {
      setLoading(false);
    }
  };


const handleSubmitImage = async () => {
  console.log("📤 Submit triggered");

  if (!validateForm1()) {
    console.warn("❌ Form validation failed.");
    return;
  }

  if (
    !formData1.image1 ||
    formData1.image1.length === 0 ||
    !selectedPatientForImage?.pk_pc_id
  ) {
    console.warn("⚠️ No image or patient selected");
    toast.warning("Please select at least one image and a valid patient.", {
      position: "top-right",
      autoClose: 3000,
    });
    return;
  }

  // setSubmissionTriggered(true); 
  // setTimeout(() => setSubmissionTriggered(true), 0);
  setSubmissionTriggerCount((prev) => prev + 1);

  setLoading1(true);

  const userId = sessionStorage.getItem("user_id");

  const formData = new FormData();
  formData.append("pid", selectedPatientForImage.pk_pc_id);
  formData.append("mode", "extra_case");
  formData.append("centre", formData1.centre1);
  formData.append("physician", formData1.physician1);
  formData.append("date", formData1.date1);
  formData.append("id", userId);

  console.log("🧾 Patient ID:", selectedPatientForImage.pk_pc_id);
  console.log("🏥 Centre:", formData1.centre1);
  console.log("👨‍⚕️ Physician:", formData1.physician1);
  console.log("📅 Date:", formData1.date1);

  // ✅ Append each image file
  formData1.image1.forEach((file, index) => {
    console.log(`📸 Adding image[${index}]:`, file.name, file.size, file.type);
    formData.append("image", file);
  });

  // 🔍 Log all formData content
  console.log("📦 Final FormData before sending:");
  for (let pair of formData.entries()) {
    if (pair[1] instanceof File) {
      console.log(`${pair[0]} => File: ${pair[1].name}, ${pair[1].size} bytes`);
    } else {
      console.log(`${pair[0]} => ${pair[1]}`);
    }
  }

  try {
    const response = await fetch(`${API_URL}/DentalNewCasePage`, {
      method: "POST",
      body: formData,
    });

    console.log("📡 Server response status:", response.status);

    if (!response.ok) throw new Error("Failed to upload image");

    toast.success("Image uploaded successfully!", {
      position: "top-right",
      autoClose: 3000,
    });
    console.log("✅ Upload success. Closing modal.");
    closeImageUploadModal();
    fetchPatients();


  setFormData1({
  centre1: "",
  physician1: "",
  date1: "",
  image1: [],
});
setSelectedPatientForImage(null);

  } catch (error) {
    console.error("🚨 Error uploading image:", error);
    toast.error("Upload failed. Please try again.", {
      position: "top-right",
      autoClose: 3000,
    });

     if (toastTimeoutRef.current) {
    clearTimeout(toastTimeoutRef.current);
    toastTimeoutRef.current = null;
  }
  if (toastIdRef.current) {
    toast.dismiss(toastIdRef.current);
    toastIdRef.current = null;
  }

  setSubmissionTriggered(false); // Cancel trigger

  } finally {
    setLoading1(false);
    console.log("🔚 Upload process complete.");
  }
};



  const styles = {
    header: {
      fontSize: "16px",
      fontWeight: "bold",
      marginBottom: "10px",
    },
    patientItem: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "12px",
      borderBottom: "1px solid #e0e0e0",
      cursor: "pointer",
    },
    imageContainer: {
      display: "flex",
      flexDirection: "column", // Ensures items are stacked vertically
      alignItems: "flex-start", // Align items to the start (left-aligned)
      gap: "15px",
      padding: "15px",
      backgroundColor: "#f9f9f9",
      borderRadius: "6px",
      margin: "5px 0",
    },

    plusButton: {
      backgroundColor: "white",
      color: "#7c4dff",
      border: "none",
      borderRadius: "5px",
      padding: "0px 10px",
      cursor: "pointer",
      display: "block",
      margin: "10px auto",
      fontSize: "25px",
    },
    imageTitle: {
      marginLeft: "5px",
      fontSize: "14px",
      color: "#333333", // Dark text color
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
    },
    horizontalLine: {
      position: "absolute",
      top: "50%",
      left: "-10px",
      width: "10px",
      height: "1px",
      backgroundColor: "#e0e0e0", // Light gray line
    },
    title: {
      fontSize: "18px",
      fontWeight: "bold",
      color: "#000",
      marginBottom: "8px",
      textAlign: "center",
    },
    text: {
      fontSize: "16px",
      color: "#333",
      fontWeight: "500",
      marginBottom: "6px",
      textTransform: "uppercase",
    },
    text1: {
      fontSize: "14px",
      color: "#333",
      fontWeight: "500",
      marginBottom: "6px",
    },
    card: {
      boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
      borderRadius: "8px",
      padding: "20px",
      backgroundColor: "#fff",
      maxWidth: "100%",
    },
    container: {
      marginLeft: "auto",
      marginRight: "auto",
      textAlign: "center",
      color: "#000",
      marginBottom: "10px",
    },
    paragraph: {
      margin: 0,
    },
    highlight: {
      margin: 0,
      color: "red",
    },

    "@media (max-width: 768px)": {
      title: {
        fontSize: "16px",
      },
      text: {
        fontSize: "14px",
      },
      text1: {
        fontSize: "12px",
      },
      container: {
        textAlign: "center",
        padding: "10px",
      },
      card: {
        padding: "15px",
      },
    },
  };

  const handleClose = () => {
    setDropdownOpen(false);
  };

  const address = {
    name: "NR MEDICAL IMAGING SDN BHD",
    street: "G05 BLOK 1 TTDI ADINA, 11 JALAN JUDO 13/45",
    area: "SEKSYEN 13 40100 SHAH ALAM",
    state: "SELANGOR DARUL EHSAN",
    contact: "Tel: 03 50360607 Fax: 03 50360609",
    email: "nrmedical.imaging.sb@gmail.com",
    website: "www.nrmedical4u.com.my",
  };

  const addressStyles = {
    container: {
      width: "100%",
      marginBottom: "10px",
      textAlign: "center",
    },
    text: {
      fontSize: "16px",
      fontWeight: "bold",
      color: "#333",
    },
    highlight: {
      fontSize: "16px",
      color: "red",
    },
  };

  const formattedDate = selectedPatient?.cm_created_at
    ? new Date(selectedPatient.cm_created_at)
        .toLocaleString("en-IN", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: true,
          timeZone: "Asia/Kolkata",
        })
        .replace(/am|pm/gi, (match) => match.toUpperCase())
    : "No Date Available";

  const printedDate = formattedDate.replace(/am|pm/gi, (match) =>
    match.toUpperCase()
  );
  const handleBlur = (e, field, index = null) => {
    const newValue = e.target.innerHTML.trim(); // Trim spaces to clean content
    setEditedContent((prev) => {
      if (index !== null) {
        // Update specific key observation
        const updatedObservations = [...prev.keyObservations];
        updatedObservations[index] = newValue;
        return { ...prev, keyObservations: updatedObservations };
      }
      // Update title or summary
      return { ...prev, [field]: newValue };
    });
  };

  const capitalize = (str) => {
    if (!str) return ""; // Handle null/undefined cases
    return str.replace(/\b\w/g, (char) => char.toUpperCase());
  };

  const updateField = (value, field, index = null) => {
    setEditedContent((prev) => {
      const updated = { ...prev };
      if (field === "keyObservations" && index !== null) {
        const updatedObservations = [...(prev.keyObservations || [])];
        updatedObservations[index] = value;
        updated.keyObservations = updatedObservations;
      } else {
        updated[field] = value;
      }
      return updated;
    });
  };

  const getColSize = () => {
    if (showLeft && showRight) return { sm: 8, md: 8, lg: 8 };
    if (showLeft && !showRight) return { sm: 9, md: 9, lg: 10 };
    if (!showLeft && showRight) return { sm: 9, md: 9, lg: 10 };
    return { sm: 12, md: 12, lg: 12 };
  };

  const colSize = getColSize();

  const getLatestDate = (images = []) => {
    if (!images || images.length === 0) return "1970-01-01";
    return images.reduce((latest, img) =>
      new Date(img.pc_created_at) > new Date(latest.pc_created_at)
        ? img
        : latest
    ).pc_created_at;
  };

  const handleRecentpatientClick = (data) => {
    console.log("Receied data", data);
    setSelectedPatient(data);
    setSelectedImage(data.image);
  };




  const [showModal, setShowModal] = useState(false);
  const [submissionTriggered, setSubmissionTriggered] = useState(false);



// useEffect(() => {
//   if (submissionTriggered) {
//     console.log("🔄 Triggered: Showing AI processing toast");

    
//     const toastId = toast.loading("Your file is being processed. Please wait...");

  
//     setTimeout(() => {
//       toast.dismiss(toastId);
//     }, 5000);

//     setSubmissionTriggered(false);
//   }
// }, [submissionTriggered]);


const toastTimeoutRef = useRef(null);
const toastIdRef = useRef(null);



useEffect(() => {
  if (submissionTriggerCount > 0) {
    console.log("🔄 Triggered: Showing AI processing toast");

    // toastIdRef.current = toast.loading("Your file is being processed. Please wait...");
    toastIdRef.current = toast.loading("Your file is being processed. Please wait...", {
      position: "top-center",
      style: {
        fontSize: "1.1rem", 
        padding: "16px 24px", 
       minWidth: "600px", 
    textAlign: "center",
      },
    });

    toastTimeoutRef.current = setTimeout(() => {
      toast.dismiss(toastIdRef.current);
      toastIdRef.current = null;
    }, 8000);

    return () => {
      if (toastTimeoutRef.current) {
        clearTimeout(toastTimeoutRef.current);
        toastTimeoutRef.current = null;
      }
    };
  }
}, [submissionTriggerCount]);


const renderSummary = (summary) => {
  if (!summary) return null;

  const isHTML = /<\/?[a-z][\s\S]*>/i.test(summary); // Simple check for HTML tags

  if (isHTML) {
    return (
      <div
        className="summary"
        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(summary) }}
      />
    );
  }

  return <p className="summary">{summary}</p>;
};




  const validateImageUrl = (primaryUrl,fallbackUrl) => {
  
    const img = new Image();
    img.src = primaryUrl;

    img.onload = () => {
      setSelectedImage(primaryUrl);
    };

    img.onerror = () => {
      const fallbackImg = new Image();
      fallbackImg.src = fallbackUrl;

      fallbackImg.onload = () => {
        setSelectedImage(fallbackUrl);
      };

      fallbackImg.onerror = () => {
        setSelectedImage(null); 
        console.error('Image not found on both sources');
      };
    };
  };




  return (
    <React.Fragment>
      <div
        style={{
          backgroundColor: "rgb(189, 213, 238)",
          minHeight: "80vh",
          width: "100vw",
          marginTop: "-20px", 
          paddingTop: "0px", 
          marginLeft: "-20px",
          marginRight: "50px",
        }}
      >
        <ToastContainer />
        <Container fluid>
          <Row>
            {/* Form Section */}
            {showLeft && (
              <Col
                sm="3"
                md="3"
                lg="2"
                className="border rounded shadow-lg p-4 bg-white"
                style={{ marginTop: "10px" }}
              >
                <Button
                  className="toggle-btn left-toggle"
                  onClick={() => setShowLeft(!showLeft)}
                >
                  <FaChevronLeft />
                </Button>
                <div style={{ ...styles.header, marginTop: "30px" }}>
                  Add New Patient
                </div>
                <form onSubmit={handleSubmit}>
                  <div className="mb-2">
                    <label className="form-label">PATIENT NAME:</label>
                    <input
                      type="text"
                      className="form-control"
                      name="name"
                      value={formData.name}
                      onChange={handleFormChange}
                      placeholder="Enter Patient Name"
                    />
                    {errors.name && (
                      <small className="text-danger">{errors.name}</small>
                    )}
                  </div>

                  <div className="mb-2">
                    <label className="form-label">GENDER:</label>
                    <Select
                      options={genderOptions}
                      value={formData.gender}
                      onChange={handleGenderChange}
                      placeholder="Select Gender"
                    />
                    {errors.gender && (
                      <small className="text-danger">{errors.gender}</small>
                    )}
                  </div>

                  <div className="mb-2">
                    <label className="form-label">PATIENT ID:</label>
                    <input
                      type="text"
                      className="form-control"
                      name="id"
                      value={formData.id}
                      onChange={handleFormChange}
                      placeholder="Enter Patient ID"
                    />
                    {errors.id && (
                      <small className="text-danger">{errors.id}</small>
                    )}
                    {patientIdExists && (
                      <small className="text-danger">
                        Patient ID already exists.
                      </small>
                    )}
                  </div>

                  <div className="mb-2">
                    <label className="form-label">ACCESSION NO.:</label>
                    <input
                      type="text"
                      className="form-control"
                      name="accessionno"
                      value={formData.accessionno}
                      onChange={handleFormChange}
                      placeholder="Enter Accession No."
                    />
                    {errors.accessionno && (
                      <small className="text-danger">
                        {errors.accessionno}
                      </small>
                    )}
                    {accessionExists && (
                      <small className="text-danger">
                        Accession No already exists.
                      </small>
                    )}
                  </div>

                  <div className="mb-2">
                    <label className="form-label">PATIENT DOB:</label>
                    <input
                      type="date"
                      className="form-control"
                      name="dob"
                      value={formData.dob}
                      onChange={handleFormChange}
                    />
                    {errors.dob && (
                      <small className="text-danger">{errors.dob}</small>
                    )}
                  </div>

                  <div className="mb-2">
                    <label className="form-label">X-RAY CENTRE:</label>
                    <input
                      type="text"
                      className="form-control"
                      name="centre"
                      value={formData.centre}
                      onChange={handleFormChange}
                      placeholder="Enter Centre Name"
                    />
                    {errors.centre && (
                      <small className="text-danger">{errors.centre}</small>
                    )}
                  </div>

                  <div className="mb-2">
                    <label className="form-label">REFERRING PHYSICIAN:</label>
                    <input
                      type="text"
                      className="form-control"
                      name="physician"
                      value={formData.physician}
                      onChange={handleFormChange}
                      placeholder="Enter Physician Name"
                    />
                    {errors.physician && (
                      <small className="text-danger">{errors.physician}</small>
                    )}
                  </div>

                  <div className="mb-2">
                    <label className="form-label">STUDY DATE:</label>
                    <input
                      type="date"
                      className="form-control"
                      name="date"
                      value={formData.date}
                      onChange={handleFormChange}
                    />
                    {errors.date && (
                      <small className="text-danger">{errors.date}</small>
                    )}
                  </div>

                  

                  <div className="mb-2">
                    <label className="form-label">
                      PATIENT X-RAY IMAGE:{" "}
                      <small className="text-muted">
                        (Only jpeg, PNG, webp | Max 9MB)
                      </small>
                    </label>
                    <input
                      type="file"
                      className="form-control"
                      name="image"
                      accept=".jpg,.jpeg,.png"
                      onChange={handleFormChange}
                      multiple
                    />
                    {errors.image && (
                      <small className="text-danger">{errors.image}</small>
                    )}
                  </div>

                  <Button
                    type="submit"
                    className="w-100"
                    disabled={loading}
                    style={{
                      marginTop: "20px",
                      backgroundColor: "rgb(34, 106, 184)",
                    }}
                  >
                    {loading ? "Processing..." : "Submit"}
                  </Button>
                </form>
              </Col>
            )}

            <Col
              {...colSize}
              className="main-column"
              style={{
                marginTop: "10px",
                position: "relative",
                paddingLeft: !showLeft ? "35px" : "10px",
                paddingRight: !showRight ? "35px" : "10px",
              }}
            >
              {/* Left Toggle Button (Appears at left end when left panel is hidden) */}
              {!showLeft && (
                <Button
                  className="toggle-btn left-toggle"
                  onClick={() => setShowLeft(true)}
                  style={{
                    position: "absolute",
                    left: "0px",
                    zIndex: 1000,
                  }}
                >
                  <FaChevronRight />
                </Button>
              )}

              {/* Right Toggle Button (Appears at right end when right panel is hidden) */}
              {!showRight && (
                <Button
                  className="toggle-btn right-toggle"
                  onClick={() => setShowRight(true)}
                  style={{
                    position: "absolute",
                    right: "0px",
                    top: "10px",
                    zIndex: 1000,
                  }}
                >
                  <FaChevronLeft />
                </Button>
              )}
              {!selectedPatient && <ChartsComponent showRight={showRight} />}

              {selectedPatient && (
                <Card className="report-card">
                  <CardBody>
                    <button
                      onClick={() => setSelectedPatient(null)}
                      style={{
                        background: "transparent",
                        border: "none",
                        fontSize: "20px",
                        cursor: "pointer",
                        color: "rgb(34, 106, 184)",
                      }}
                    >
                      &#8592;
                    </button>
                    <div className="report-header">
                      <div className="report-title">Patient Report</div>
                      <div className="action-buttons">
                        {viewingHistory && (
                          <button
                            onClick={() => {
                              setSelectedPatient(originalPatient);
                              setOriginalPatient(null);
                              setViewingHistory(false);
                            }}
                            style={{
                              background: "#f0f0f0",
                              border: "1px solid #ccc",
                              borderRadius: "5px",
                              padding: "5px 10px",
                              marginLeft: "10px",
                              fontSize: "0.9rem",
                              cursor: "pointer",
                            }}
                          >
                            Reset to Current Report
                          </button>
                        )}
                        <button
                          style={{
                            width: "40px",
                            height: "40px",
                            backgroundColor: "#e0eafc",
                            borderRadius: "8px",
                            border: "none",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            if (!selectedPatient) {
                              toast.error("Please select a patient first!", {
                                position: "top-right",
                                autoClose: 3000,
                                hideProgressBar: true,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                              });
                              return;
                            }

                            const filtered = historyList.filter(
                              (item) =>
                                item.patient_id === selectedPatient.patient_id
                            );
                            setFilteredHistoryList(filtered);

                            setDropdownOpen(!dropdownOpen);
                          }}
                        >
                          <GoHistory size={22} color="blue" />
                        </button>
                        {dropdownOpen && (
                          <div
                            style={{
                              position: "absolute",
                              top: "80px",
                              right: "0",
                              width: "250px",
                              backgroundColor: "white",
                              boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
                              borderRadius: "8px",
                              padding: "10px",
                              zIndex: "1000",
                            }}
                          >
                            <h6
                              style={{
                                margin: "0 0 5px 0",
                                fontWeight: "bold",
                                textAlign: "left",
                              }}
                            >
                              Log List
                            </h6>
                            <button
                              onClick={handleClose}
                              style={{
                                position: "absolute",
                                top: "5px",
                                right: "5px",
                                background: "transparent",
                                border: "none",
                                fontSize: "16px",
                                cursor: "pointer",
                              }}
                            >
                              ✖
                            </button>
                            <ul
                              style={{
                                listStyle: "none",
                                padding: "0",
                                margin: "0",
                                maxHeight: "200px",
                                overflowY: "auto",
                              }}
                            >
                              {selectedPatient ? (
                                (() => {
                                  const filteredReports = historyList.filter(
                                    (report) =>
                                      report.patient_id ===
                                      selectedPatient.patient_id
                                    // report.id === selectedPatient.case_id
                                  );

                                  return filteredReports.length > 0 ? (
                                    filteredReports.map((report) => (
                                      <li
                                        key={report.id}
                                        style={{
                                          padding: "8px",
                                          borderBottom: "1px solid #ddd",
                                          cursor: "pointer",
                                          transition: "background 0.2s",
                                        }}
                                        onClick={() =>
                                          handleHistoryClick(report)
                                        }
                                        onMouseOver={(e) =>
                                          (e.target.style.backgroundColor =
                                            "#f1f1f1")
                                        }
                                        onMouseOut={(e) =>
                                          (e.target.style.backgroundColor =
                                            "white")
                                        }
                                      >
                                        <strong>{report.title}</strong>
                                        <br />
                                        <span
                                          style={{
                                            fontSize: "12px",
                                            color: "gray",
                                          }}
                                        >
                                          {report.created_at}
                                        </span>
                                      </li>
                                    ))
                                  ) : (
                                    <li
                                      style={{
                                        textAlign: "center",
                                        color: "gray",
                                      }}
                                    >
                                      No history available
                                    </li>
                                  );
                                })()
                              ) : (
                                <li
                                  style={{ textAlign: "center", color: "gray" }}
                                >
                                  Select a patient to view history
                                </li>
                              )}
                            </ul>
                          </div>
                        )}
                        {!viewingHistory && (
                          <button
                            className="icon-button"
                            onClick={() => {
                              if (!selectedPatient) {
                                toast.error("Please select a patient first!", {
                                  position: "top-right",
                                  autoClose: 3000,
                                  hideProgressBar: true,
                                  closeOnClick: true,
                                  pauseOnHover: true,
                                  draggable: true,
                                });
                                return;
                              }
                              toggleModal(selectedPatient);
                            }}
                          >
                            <CiEdit size={22} color="blue" />
                          </button>
                        )}

                        <button
                          className="icon-button"
                          onClick={() => {
                            if (!selectedPatient) {
                              toast.error("Please select a patient first!", {
                                position: "top-right",
                                autoClose: 3000,
                                hideProgressBar: true,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                              });
                              return;
                            }
                            handleDownloadPDF();
                          }}
                        >
                          <BsDownload size={22} color="blue" />
                        </button>
                      </div>
                    </div>

                    <div id="pdf-content">
                      {selectedPatient ? (
                        <div className="report-content">
                          <div className="patient-details">
                            <p>
                              <span className="label">Patient Name:</span>{" "}
                              <span className="value">
                                {capitalize(selectedPatient.patient_name)}
                              </span>
                            </p>
                            <p>
                              <span className="label">Gender:</span>{" "}
                              <span className="value">
                                {capitalize(selectedPatient.gender)}
                              </span>
                            </p>
                            <p>
                              <span className="label">Patient Id:</span>{" "}
                              <span className="value">
                                {selectedPatient.patient_id}
                              </span>
                            </p>
                            <p>
                              <span className="label">Accession Number:</span>{" "}
                              <span className="value">
                                {selectedPatient.accession_no}
                              </span>
                            </p>
                            <p>
                              <span className="label">DOB:</span>{" "}
                              <span className="value">
                                {selectedPatient.patient_dob}
                              </span>
                            </p>
                            <p>
                              <span className="label">X-Ray Centre:</span>{" "}
                              <span className="value">
                                {capitalize(selectedPatient.organization)}
                              </span>
                            </p>
                            <p>
                              <span className="label">
                                Referring Physician:
                              </span>{" "}
                              <span className="value">
                                {capitalize(selectedPatient.provider)}
                              </span>
                            </p>
                            <p>
                              <span className="label">Study Date:</span>{" "}
                              <span className="value">
                                {capitalize(selectedPatient.service_date)}
                              </span>
                            </p>
                            <p>
                              <span className="label">
                                Date of Case Registration:
                              </span>{" "}
                              <span className="value">
                                {new Date(
                                  selectedPatient.cm_created_at
                                ).toLocaleDateString("en-GB", {
                                  day: "2-digit",
                                  month: "long",
                                  year: "numeric",
                                })}
                              </span>
                            </p>

                            {selectedImage && (
                              <img
                                src={selectedImage}
                                alt="Patient X-Ray"
                                className="xray-image"
                              />
                            )}
                          </div>

                          <div className="report-details">
                            <h5 className="report-title">
                              Patient Report Details
                            </h5>
                            <p className="report-field">
                              <strong>Title:</strong> {selectedPatient.title}
                            </p>

                            <h6 className="section-title">Summary</h6>
                            
{renderSummary(selectedPatient.summary)}

                            <h6 className="section-title">Key Observations</h6>
                            {selectedPatient.data_points ? (
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: selectedPatient.data_points,
                                }}
                              />
                            ) : (
                              <p className="no-report">
                                No detailed report available.
                              </p>
                            )}
                          </div>
                        </div>
                      ) : (
                        <p className="text-muted text-center">
                          Select a patient to view details.
                        </p>
                      )}
                    </div>
                  </CardBody>
                  <button
                    onClick={toggleChatPopup}
                    className="chat-btn"
                    style={{ marginBottom: "-10px" }}
                  >
                    <img src={chatbot} alt="chat bot" className="chat-img" />
                  </button>
                </Card>
              )}

              {!selectedPatient && (
                <RecentList
                  handleRecentpatientClick={handleRecentpatientClick}
                />
              )}

              <style jsx>{`
                .main-column {
                  height: 90vh;
                  overflow-y: auto;
                  padding-right: 10px;
                }

                .report-card {
                  padding: 15px;
                  height: ${selectedPatient
                    ? "95vh"
                    : "auto"}; /* Increased height */
                  overflow-y: auto;
                }

                .report-header {
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                }

                .report-title {
                  font-weight: bold;
                  font-size: 20px;
                }

                .action-buttons {
                  display: flex;
                  gap: 8px;
                }

                .icon-button {
                  width: 40px;
                  height: 40px;
                  background-color: #e0eafc;
                  border-radius: 8px;
                  border: none;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  cursor: pointer;
                }

                .dropdown-menu {
                  position: absolute;
                  top: 80px;
                  right: 0;
                  width: 250px;
                  background-color: white;
                  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
                  border-radius: 8px;
                  padding: 10px;
                  z-index: 1000;
                }

                .dropdown-title {
                  margin: 0 0 5px 0;
                  font-weight: bold;
                  text-align: left;
                }

                .close-button {
                  position: absolute;
                  top: 5px;
                  right: 5px;
                  background: transparent;
                  border: none;
                  font-size: 16px;
                  cursor: pointer;
                }

                .log-list {
                  list-style: none;
                  padding: 0;
                  margin: 0;
                  max-height: 200px;
                  overflow-y: auto;
                }

                .log-item {
                  padding: 8px;
                  border-bottom: 1px solid #ddd;
                  cursor: pointer;
                  transition: background 0.2s;
                }

                .log-item:hover {
                  background-color: #f1f1f1;
                }

                .log-date {
                  font-size: 12px;
                  color: gray;
                }

                .log-empty {
                  text-align: center;
                  color: gray;
                }

                .report-content {
                  display: flex;
                  gap: 20px;
                  height: 100%;
                }

                .patient-details {
                  flex: 1;
                  background-color: #f8f9fa;
                  padding: 15px;
                  border-radius: 8px;
                  min-height: 300px;
                }

                .label {
                  color: #6c757d;
                  font-weight: 500;
                }
                p {
                  margin-bottom: 10px; /* Adjust spacing as needed */
                }

                .value {
                  color: #212529;
                  font-weight: bold;
                }

                .xray-image {
                  width: 300px;
                  height: 400px;
                  object-fit: contain; /* Show whole image without cropping */
                  border-radius: 8px;
                  background-color: rgb(
                    17,
                    16,
                    16
                  ); /* Optional: adds background behind the image */
                }

                .report-details {
                  flex: 2;
                  background-color: #f8f9fa;
                  padding: 15px;
                  border-radius: 8px;
                  max-height: 1000px;
                  overflow-y: auto;
                  border: 1px solid #ddd;
                }

                .report-title {
                  text-align: center;
                  // text-decoration: underline;
                }

                .report-field {
                  font-weight: bold;
                  font-size: 16px;
                  margin-bottom: 5px;
                }

                .section-title {
                  font-weight: bold;
                  margin-top: 10px;
                  margin-bottom: 5px;
                }

                .summary {
                  font-size: 14px;
                  color: #555;
                  text-align: justify;
                  margin-bottom: 15px;
                }

                .no-report {
                  color: gray;
                }

                .chat-btn {
                  position: fixed;
                  bottom: 20px;
                  right: 20px;
                  background: none;
                  border: none;
                  cursor: pointer;
                }

                .chat-img {
                  width: 50px;
                  height: 50px;
                }
              `}</style>
            </Col>
            {showRight && (
              <Col
                sm="3"
                md="3"
                lg="2"
                className="border rounded shadow-lg p-4 bg-white"
                style={{
                  marginTop: "10px",
                  height: "910px", // Increased height to give more space
                  display: "flex",
                  flexDirection: "column", // Allow child components to be arranged vertically
                }}
              >
                <Button
                  className="toggle-btn right-toggle"
                  onClick={() => setShowRight(!showRight)}
                >
                  <FaChevronRight />
                </Button>

                {/* Fixed header */}
                <div style={{ ...styles.header, marginTop: "30px" }}>
                  Patient Informations
                </div>

                {/* Scrollable list container */}
                <div
                  style={{
                    flex: 1, // Take up remaining space
                    overflowY: "auto", // Make the list scrollable
                  }}
                >
                  {Object.entries(groupedPatients)
                    .sort(([, a], [, b]) => {
                      const aLatest = getLatestDate(a.images);
                      const bLatest = getLatestDate(b.images);
                      return new Date(bLatest) - new Date(aLatest); // Descending
                    })
                    .filter(([, patientData]) =>
                      patientData.patient_name
                        .toLowerCase()
                        .includes(searchTerm.toLowerCase())
                    )
                    .map(([fk_pc_id, patientData]) => (
                      <div key={fk_pc_id}>
                        <div
                          style={styles.patientItem}
                          onClick={() =>
                            setExpandedPatients((prev) => ({
                              [fk_pc_id]: !prev[fk_pc_id], 
                            }))
                          }
                        >
                          <span>{capitalize(patientData.patient_name)}</span>
                          {expandedPatients[fk_pc_id] ? (
                            <FaChevronUp />
                          ) : (
                            <FaChevronDown />
                          )}
                        </div>

                        {expandedPatients[fk_pc_id] && (
                          <div style={styles.imageContainer}>
                            {patientData.images.map((image, index) => (
                              <div
                                key={fk_pc_id}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "8px",
                                  padding: "5px",
                                  borderRadius: "4px",
                                }}
                              >
                                <img
                                  src={XrayImage}
                                  alt="X-ray Icon"
                                  style={{ width: "32px", height: "32px" }}
                                />
                                <span
                                  onClick={async() => {
                                    setDropdownOpen(false);
                                    setViewingHistory(false);
                                    setOriginalPatient(null);

                                    const primaryUrl = `${IMAGE_URL}/${image.file_name}`;
                                    const fallbackUrl = `${IMAGE_URL2}/${image.file_name}`;

                                    const resolvedImageUrl = await validateImageUrl(primaryUrl, fallbackUrl);
                                    setSelectedPatient({
                                      ...patientData,
                                      case_id: image.case_id,
                                      pk_pc_id: image.pk_pc_id,
                                      title: image.title,
                                      summary: image.summary,
                                      data_points: image.data_points,
                                      file_name: image.file_name,
                                      // image: `${IMAGE_URL}/${image.file_name}`,
                                      image: resolvedImageUrl,
                                      provider: image.provider,
                                      organization: image.organization,
                                      service_date: image.service_date,
                                      patient_id: image.patient_id,
                                      accession_no: image.accession_no,
                                      patient_dob: image.patient_dob,
                                      cm_created_at: image.cm_created_at,
                                      pc_created_at: image.pc_created_at,
                                      gender: image.gender,
                                    });
                                    setSelectedImage(
                                      resolvedImageUrl
                                    );
                                    // setSelectedImage(
                                    //   `${IMAGE_URL}/${image.file_name}`
                                    // );
                                  }}
                                  style={{ cursor: "pointer" }}
                                >
                                  {capitalize(image.title)}
                                </span>
                              </div>
                            ))}

                            <button
                              style={styles.plusButton}
                              onClick={() => openImageUploadModal(patientData)}
                              title="Add Image"
                            >
                              +
                            </button>
                          </div>
                        )}
                      </div>
                    ))}
                </div>
              </Col>
            )}

            <Modal
              isOpen={modalOpen}
              toggle={toggleModal}
              size="xl"
              style={{ maxHeight: "90vh" }}
            >
              <ModalHeader toggle={toggleModal}>Edit Report</ModalHeader>
              <ModalBody
                style={{
                  maxHeight: "70vh",
                  overflowY: "auto",
                  paddingRight: "10px",
                }}
              >
                {/* Title */}
                <h4>Title:</h4>
                <h2
                  contentEditable
                  suppressContentEditableWarning
                  onBlur={(e) =>
                    updateField(e.currentTarget.textContent, "title")
                  }
                  style={{
                    fontSize: "1.2rem",
                    fontWeight: "500",
                    minHeight: "40px",
                    cursor: "text",
                  }}
                >
                  {editedContent.title}
                </h2>

                {/* Summary */}
                <h4>Summary:</h4>
                <p
                  contentEditable
                  suppressContentEditableWarning
                  onBlur={(e) =>
                    updateField(e.currentTarget.textContent, "summary")
                  }
                  style={{
                    fontSize: "1.2rem",
                    fontWeight: "500",
                    minHeight: "40px",
                    cursor: "text",
                  }}
                >
                  {editedContent.summary}
                </p>

                {/* Key Observations */}
                <h4 style={{ marginTop: "1.0rem" }}>Key Observations:</h4>
                <ul>
                  {(editedContent.keyObservations || []).map(
                    (feature, index) => (
                      <li
                        key={index}
                        contentEditable
                        suppressContentEditableWarning
                        onBlur={(e) =>
                          updateField(
                            e.currentTarget.textContent,
                            "keyObservations",
                            index
                          )
                        }
                        style={{
                          fontSize: "1.2rem",
                          fontWeight: "500",
                          minHeight: "40px",
                          cursor: "text",
                          listStyleType: "disc",
                          marginBottom: "2px",
                        }}
                      >
                        {feature}
                      </li>
                    )
                  )}
                </ul>
              </ModalBody>

              <ModalFooter>
                <Button
                  onClick={handleSaveEdit}
                  style={{ backgroundColor: "rgb(34, 106, 184)" }}
                >
                  Save
                </Button>
                <Button
                  onClick={toggleModal}
                  style={{ backgroundColor: "rgb(34, 106, 184)" }}
                >
                  Cancel
                </Button>
              </ModalFooter>
            </Modal>

            <Modal isOpen={imageModalOpen} toggle={closeImageUploadModal}>
              <ModalHeader toggle={closeImageUploadModal}>
                Upload X-Ray Image
              </ModalHeader>
              <ModalBody>
                {selectedPatientForImage && (
                  <>
                    <div className="mb-2">
                      <label className="form-label">X-RAY CENTRE:</label>
                      <input
                        type="text"
                        className="form-control"
                        name="centre1"
                        value={formData1.centre1}
                        onChange={handleFormChange1}
                        placeholder="Enter Centre Name"
                      />
                      {errors1.centre1 && (
                        <small className="text-danger">{errors1.centre1}</small>
                      )}
                    </div>

                    <div className="mb-2">
                      <label className="form-label">REFERRING PHYSICIAN:</label>
                      <input
                        type="text"
                        className="form-control"
                        name="physician1"
                        value={formData1.physician1}
                        onChange={handleFormChange1}
                        placeholder="Enter Physician Name"
                      />
                      {errors1.physician1 && (
                        <small className="text-danger">
                          {errors1.physician1}
                        </small>
                      )}
                    </div>

                    <div className="mb-2">
                      <label className="form-label">STUDY DATE:</label>
                      <input
                        type="date"
                        className="form-control"
                        name="date1"
                        value={formData1.date1}
                        onChange={handleFormChange1}
                      />
                      {errors1.date1 && (
                        <small className="text-danger">{errors1.date1}</small>
                      )}
                    </div>

                    <div className="mb-2">
                      <label className="form-label">
                        PATIENT X-RAY IMAGE:{" "}
                        <small className="text-muted">
                          (Only jpeg, PNG, webp | Max 9MB)
                        </small>
                      </label>
                      <input
                        type="file"
                        className="form-control"
                        name="image1"
                        accept=".jpg,.jpeg,.png"
                        onChange={handleFormChange1}
                        multiple
                      />
                      {errors1.image1 && (
                        <small className="text-danger">{errors1.image1}</small>
                      )}
                    </div>
                  </>
                )}
              </ModalBody>
              <ModalFooter>
                <Button
                  style={{ backgroundColor: "rgb(34, 106, 184)" }}
                  onClick={closeImageUploadModal}
                >
                  Cancel
                </Button>
                <Button
                  style={{ backgroundColor: "rgb(34, 106, 184)" }}
                  onClick={handleSubmitImage}
                  disabled={loading1}
                >
                  {loading1 ? "Processing..." : "Upload"}
                </Button>
              </ModalFooter>
            </Modal>
          </Row>
        </Container>
      
      
    
      </div>

      {/* Chat Popup */}
      {isChatPopupOpen && (
        <div className="chat-popup">
          <div className="chat-header">
            <span className="bold">AttestaAI ChatBot</span>
            <Button color="danger" size="sm" onClick={toggleChatPopup}>
              X
            </Button>
          </div>
          <div className="chat-content">
            <div className="chat-body">
              {conversation.length > 0 && (
                <div className="conversation">
                  {conversation.map((msg, index) => (
                    <div key={index} className="message-pair">
                      {/* User Question */}
                      <div className="user-message-box">
                        <p>
                          <strong>You:</strong>{" "}
                          <span className="user-message">{msg.question}</span>
                        </p>
                      </div>

                      {/* Bot Answer */}
                      <div className="bot-message-box">
                        <p>
                          <strong>AttestaAI: </strong>
                          <span className="bot-message">
                            {msg.answer === "..." ? (
                              <span className="loader-dot">
                                Loading<span className="dot one">.</span>
                                <span className="dot two">.</span>
                                <span className="dot three">.</span>
                              </span>
                            ) : 
                            // (
                            //   // msg.answer?.replace(/\*\*/g, "")
                            //   // <div
                            //   //           dangerouslySetInnerHTML={{
                            //   //             __html: DOMPurify.sanitize(msg.answer?.replace(/\*\*/g, ""))
                            //   //           }}
                            //   //         />
                            //   // <TypingHTML html={msg.answer?.replace(/\*\*/g, "")} duration={3000} />
                            // )
                            msg.isNew ? (
              
              <TypingHTML html={msg.answer?.replace(/\*\*/g, "")} duration={3000} />
            ) : (
              
              <div
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(msg.answer?.replace(/\*\*/g, "")),
                }}
              />
            )
                            }
                          </span>
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              )}

              <div ref={messagesEndRef} />
            </div>

            {showWarning && (
              <div
                className="warning-message"
                style={{ color: "red", marginTop: "10px" }}
              >
                <strong>
                  Please select a patient before submitting your question.
                </strong>
              </div>
            )}

            {/* Sticky Footer (Input) */}
            <div className="chat-input">
              <textarea
                className="form-control"
                rows={2}
                placeholder="Type your question..."
                value={question}
                onKeyDown={handleKeyDown} // Add the keydown event handler
                onChange={(e) => setQuestion(e.target.value)} // Update question on input change
              />
              <div className="d-flex mt-2">
                <Button
                  onClick={handleSubmitQuestion} // On button click, submit the question
                  className="me-2"
                  style={{ backgroundColor: "rgb(34, 106, 184)" }}
                >
                  Submit
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* Responsive Styles */}
      <style jsx="true">{`
        .toggle-btn {
          position: absolute;
          top: 10px;
          background: rgb(34, 106, 184);
          border: none;
          cursor: pointer;
          font-size: 10px;
        }
        .left-toggle {
          left: 10px;
          top: 10px;
        }
        .right-toggle {
          right: 10px;
          top: 10px;
        }
        .main-column {
          transition: width 0.3s ease-in-out;
        }
        .chat-btn {
          position: absolute;
          bottom: 20px;
          right: 20px;
          z-index: 2;
          width: 50px;
          height: 50px;
          padding: 0;
          border: none;
          background: none;
        }
        .custom-chat-img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
        .chat-btn {
          position: absolute;
          bottom: 20px;
          right: 20px;
          z-index: 2;
          width: 50px;
          height: 50px;
          padding: 0;
          border: none;
          background: none;
        }
        .custom-chat-img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }

        /* 
          FIXED SIZE POPUP
          -> Forcibly keep the popup at a fixed width & height
          -> Overflow will scroll
        */
        .chat-popup {
          position: absolute;
          bottom: 75px;
          right: 20px;
          width: 350px;
          height: 470px; /* Fixed height, not just max-height */
          background: #fff;
          border: 1px solid #ccc;
          box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
          z-index: 3;
          display: flex;
          flex-direction: column;
        }

        .chat-header {
          padding: 8px;
          background: #f5f5f5;
          border-bottom: 1px solid #ccc;
          display: flex;
          justify-content: space-between;
        }

        .chat-content {
          flex: 1; /* fill remaining vertical space */
          display: flex;
          flex-direction: column;
          overflow: hidden; /* ensure no expansion beyond 500px height */
        }

        .chat-body {
          flex: 1; /* scrollable area for messages */
          padding: 10px;
          overflow-y: auto;
          word-wrap: break-word;
        }

        .chat-input {
          border-top: 1px solid #ccc;
          padding: 10px;
          background: #fff;
        }

        .conversation {
          disply: flex;
          flex-direction: column;
          gap: 15px;
          padding: 10px;
        }

        .message-pair {
          display: flex;
          flex-direction: column;
          gap: 15px;
          margin-bottom: 20px;
        }

        .user-message-box {
          background-color: #ededed;
          padding: 10px;
          border-radius: 8px;
          align-self: felx-start;
        }

        .message {
          margin-bottom: 8px;
          padding: 6px;
          background: #e9ecef;
          border-radius: 4px;
        }
        .bot-message-box {
          background-color: #ededed; /* Light red for bot */
          padding: 10px;
          border-radius: 8px;
          align-self: flex-start; /* Align left */
        }

        .user-message {
          color: #000; /* Dark teal */
          font-weight: bold;
        }

        .bot-message {
          color: #000; /* Dark red */
          font-weight: bold;
        }

        .user-message {
          word-wrap: break-word;
        }

        .loader-dot {
          font-style: italic;
          color: gray;
        }

        .loader-dot .dot {
          animation: blink 1.4s infinite;
          font-weight: bold;
        }

        .loader-dot .dot.one {
          animation-delay: 0s;
        }

        .loader-dot .dot.two {
          animation-delay: 0.2s;
        }

        .loader-dot .dot.three {
          animation-delay: 0.4s;
        }

        @keyframes blink {
          0% {
            opacity: 0.2;
          }
          20% {
            opacity: 1;
          }
          100% {
            opacity: 0.2;
          }
        }
        .full-screen {
          display: flex;
          flex-direction: column;
          height: 100vh;
          overflow: hidden;
        }

        .report-card {
          box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
          border: none;
          background-color: #fff;
          border-radius: 8px;
          height: auto;
        }

        .report-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 16px;
        }

        .icon-button {
          width: 40px;
          height: 40px;
          background-color: #e0eafc;
          border-radius: 8px;
          border: none;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
        }
      `}</style>

    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  searchTerm: state.searchTerm.searchTerm, // Access searchTerm from the Redux store
});

export default connect(mapStateToProps)(Dashboard);
